'use client'
import * as React from 'react'
import { Icon, type IconProps } from '../Icon'
const PencilIcon = React.forwardRef((props: IconProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      viewBox="0 0 24 24"
      ref={ref}
      {...props}
    >
      <path d="M21.3103 6.87817L17.1216 2.68848C16.9823 2.54916 16.8169 2.43864 16.6349 2.36324C16.4529 2.28783 16.2578 2.24902 16.0608 2.24902C15.8638 2.24902 15.6687 2.28783 15.4867 2.36324C15.3047 2.43864 15.1393 2.54916 15 2.68848L3.43969 14.2497C3.2998 14.3885 3.18889 14.5537 3.11341 14.7357C3.03792 14.9178 2.99938 15.113 3.00001 15.31V19.4997C3.00001 19.8976 3.15804 20.2791 3.43935 20.5604C3.72065 20.8417 4.10218 20.9997 4.50001 20.9997H8.6897C8.88675 21.0004 9.08197 20.9618 9.26399 20.8863C9.44602 20.8109 9.61122 20.6999 9.75001 20.56L21.3103 8.99973C21.4496 8.86044 21.5602 8.69507 21.6356 8.51306C21.711 8.33105 21.7498 8.13596 21.7498 7.93895C21.7498 7.74194 21.711 7.54686 21.6356 7.36485C21.5602 7.18284 21.4496 7.01746 21.3103 6.87817ZM4.81032 14.9997L12.75 7.06005L14.3147 8.62473L6.37501 16.5635L4.81032 14.9997ZM4.50001 16.81L7.1897 19.4997H4.50001V16.81ZM9.00001 19.1894L7.43532 17.6247L15.375 9.68505L16.9397 11.2497L9.00001 19.1894ZM18 10.1894L13.8103 5.99973L16.0603 3.74973L20.25 7.93848L18 10.1894Z" />
    </Icon>
  )
})
export { PencilIcon }
